import script from "./CreateTaskDia.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTaskDia.vue?vue&type=script&setup=true&lang=js"

import "./CreateTaskDia.vue?vue&type=style&index=0&id=1e4de6c5&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4de6c5"]])

export default __exports__